<template>
  <div class="activity">
    <div class="container">
      <div class="activity-register">
        <div class="caption">
          <div class="title-task">
            <i class="icon-dailytask_1"></i>
            <div class="label-box">
              <span class="label-shadow">每日任务</span>
              <span class="label-text">每日任务</span>
            </div>
          </div>
        </div>
        <div class="content">
          <div class="item" v-for="(value, index) in dailyTasks" :key="index">
            <div class="item-wrap">
              <div class="item-left">
                <div class="item-icon">
                  <div class="icon" :style="{ 'background-image': `url(${value.imgUrl})` }"></div>
                  <div class="tip">
                    <div class="label-box">
                      <span class="label-shadow">{{ value.coins }}</span>
                      <span class="label-text">{{ value.coins }}</span>
                    </div>
                  </div>
                </div>
                <div class="desc">{{ value.title }}</div>
              </div>

              <div class="item-right">
                <span class="time-target">({{ value.progress }}/{{ value.progressTotal }})</span>
                <button
                  class="button-status"
                  :class="classMode[value.status]"
                  @click="handleStatusClick(value.status, value, index, true)"
                >
                  <div class="label-box">
                    <span class="label-shadow">{{ statusMode[value.status] }}</span>
                    <span class="label-text">{{ statusMode[value.status] }}</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="cumulative" :class="{ None_DataTaskII: filteredDataTaskII.length === 0 }">
          <div class="content DataTaskI1">
            <div class="title-task">
              <i class="icon-addtask1_1"></i>
              <div class="label-box">
                <span class="label-shadow">累计任务一</span>
                <span class="label-text">累计任务一</span>
              </div>
            </div>
            <div class="item" v-for="(value, index) in filteredDataTaskI1" :key="value.id">
              <div class="item-wrap">
                <div class="item-left">
                  <div class="item-icon">
                    <div class="icon" :style="{ 'background-image': `url(${value.imgUrl})` }"></div>
                    <div class="tip">
                      <div class="label-box">
                        <span class="label-shadow">{{ value.coins }}</span>
                        <span class="label-text">{{ value.coins }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="desc">{{ value.title }}</div>
                </div>

                <div class="item-right">
                  <span class="time-target">({{ value.progress }}/{{ value.progressTotal }})</span>
                  <button
                    class="button-status"
                    :class="classMode[value.status]"
                    @click="handleStatusClick(value.status, value, index, false)"
                  >
                    <div class="label-box">
                      <span class="label-shadow">{{ statusMode[value.status] }}</span>
                      <span class="label-text">{{ statusMode[value.status] }}</span>
                    </div>
                  </button>
                </div>
              </div>
              <div :class="{ 'item-line': index < cumulativeTasks.length - 2 }"></div>
            </div>
          </div>
          <div class="content DataTaskII">
            <div class="title-task">
              <i class="icon-addtask2_1"></i>
              <div class="label-box">
                <span class="label-shadow">累计任务二</span>
                <span class="label-text">累计任务二</span>
              </div>
            </div>
            <div class="item" v-for="(value, index) in filteredDataTaskII" :key="value.id">
              <div class="item-wrap">
                <div class="item-left">
                  <div class="item-icon">
                    <div class="icon" :style="{ 'background-image': `url(${value.imgUrl})` }"></div>
                    <div class="tip">
                      <div class="label-box">
                        <span class="label-shadow">{{ value.coins }}</span>
                        <span class="label-text">{{ value.coins }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="desc">{{ value.title }}</div>
                </div>

                <div class="item-right">
                  <span class="time-target">({{ value.progress }}/{{ value.progressTotal }})</span>
                  <button
                    class="button-status"
                    :class="classMode[value.status]"
                    @click="handleStatusClick(value.status, value, index, false)"
                  >
                    <div class="label-box">
                      <span class="label-shadow">{{ statusMode[value.status] }}</span>
                      <span class="label-text">{{ statusMode[value.status] }}</span>
                    </div>
                  </button>
                </div>
              </div>
              <div :class="{ 'item-line': index < cumulativeTasks.length - 2 }"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useAppStore } from '@/store'
import * as api from '@/service/index'
import { usePrompt } from '@/composables/usePrompt'

const appStore = useAppStore()

// status 三态显隐/配色映射: 0 未完成 / 1 可领取 / 2 已领取
const classMode = ['undone', 'receive', 'received']
const statusMode = ['未完成', '领取', '已领取']

const listData = ref([[], []])   // [dailyTasks, cumulativeTasks]
const inRequest = ref(false)     // 领奖 API 锁, 阻塞并发点击
const { showPrompt } = usePrompt()

const token = computed(() => appStore.token)
const amount = computed(() => appStore.amount)

const dailyTasks = computed(() => listData.value[0] || [])
const cumulativeTasks = computed(() => listData.value[1] || [])
// 累计任务按 id 后缀数字段分左右两列: task4-12 → 左, task13-19 → 右
const filteredDataTaskI1 = computed(() => cumulativeTasks.value.filter(item => {
  const n = parseInt(item.id.slice(4))
  return n >= 4 && n <= 12
}))
const filteredDataTaskII = computed(() => cumulativeTasks.value.filter(item => {
  const n = parseInt(item.id.slice(4))
  return n >= 13 && n <= 19
}))

async function fetchActivityList() {
  if (!token.value) return
  try {
    const res = await api.getActivityList({ token: token.value, taskType: 1 })
    if (res.status === 200) {
      const { cumulative, dailyTasks } = res.data
      listData.value = [dailyTasks, cumulative]
    } else {
      showPrompt(res.data)
    }
  } catch (err) {
    console.log(err)
  }
}

function formatDay(time) {
  const dateObj = new Date(time)
  let month = dateObj.getMonth() + 1
  month = month < 10 ? '0' + month : month
  let day = dateObj.getDate()
  day = day < 10 ? '0' + day : day
  return `${month}月${day}日`
}

async function handleStatusClick(status, value, index, isDaily) {
  if (classMode[status] !== 'receive' || inRequest.value) return
  inRequest.value = true

  // 乐观更新: 立即把该项 status 置为已领取, 后端拒绝再靠 fetchActivityList 覆盖
  if (isDaily) {
    listData.value[0][index].status = 2
  } else {
    const itemIndex = listData.value[1].findIndex(item => item.id === value.id)
    if (itemIndex !== -1) {
      listData.value[1][itemIndex].status = 2
    }
  }

  if (!token.value) {
    inRequest.value = false
    return
  }

  try {
    const response = await api.getActivityReward(token.value, { taskId: value.id })
    const dbtitle = isDaily ? '每日任务领取奖励' : '累计任务领取奖励'
    if (response.status === 200 && response.data === true) {
      fetchActivityList()
      appStore.reqRedDotState()
      const now = await api.reqcurrentTime()

      if (value.isSend) {
        // 道具类奖励: 拉最新礼物列表, 埋点道具余量
        const res = await api.reqGiftList({ token: token.value, force: true })
        if (res.status === 200) {
          res.data?.find(item => {
            if (typeof tapdb === 'undefined') return
            if (item.giftId === 'xc006' && now.status === 200) {
              const countdown = formatDay(now.data)
              tapdb.trackEvent(dbtitle, {
                '#mission_unique_id': value.id + '+' + countdown,
                '#item_gain': +value.coins,
                '#prop_after': item.count,
                '#prop_id': item.giftId,
                '#prop_type': value.title
              })
            }
          })
        }
      } else {
        // 货币类奖励: 刷新用户信息, 埋点货币余量
        appStore.reqUserInfo(true)
        if (now.status === 200 && typeof tapdb !== 'undefined') {
          const countdown = formatDay(now.data)
          tapdb.trackEvent(dbtitle, {
            '#mission_unique_id': value.id + '+' + countdown,
            '#value_change': +value.coins,
            '#value_after': +amount.value.quizRemainNum,
            '#coin_id': value.id,
            '#via_type': value.desc
          })
        }
      }

      showPrompt('领取成功～')
    }
  } catch (err) {
    console.log(err)
  } finally {
    inRequest.value = false
  }
}

fetchActivityList()
</script>

<style lang="scss" scoped>
@import "./index";
</style>
